import type { RunStatus } from '../domain/types';

interface Props {
  status: RunStatus | null;
  summary: string | null;
}

const STATUS_LABEL: Record<RunStatus, string> = {
  completed: 'Completado',
  partial: 'Parcial',
  failed: 'Fallido',
  cancelled: 'Cancelado',
};

export function ResultSummary({ status, summary }: Props) {
  if (!status) {
    return <p className="empty-state">Sin hallazgos todavía.</p>;
  }
  return (
    <div>
      <p className="result-summary">
        <span className={`result-summary__badge badge--${status}`}>{STATUS_LABEL[status]}</span>
      </p>
      {summary ? <p>{summary}</p> : null}
    </div>
  );
}
